<p-confirmDialog header="Deleting Booking Report Template"></p-confirmDialog>
<p-table [value]="pdfTemplateService.bookingPdftemplates">
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>Category</th>
            <th>Name</th>
            <th>Language</th>
            <th>Last modified</th>
            <th>Last modified by</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>{{template.id}}</td>
            <td>{{template.pdfDocumentCategory.name}}</td>
            <td>
                <a (click)="editSelectedBookingPdfTemplate(template)">
                    {{template.name}}
                </a>
            </td>
            <td>
                {{template.documentLanguage.name}}
            </td>
            <td>
                {{template.lastModified | date:'dd/MM/yyyy HH:mm'}}
            </td>
            <td>
                {{template.lastModifiedBy.name}}
            </td>
            <td>
                <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deleteTemplate(template.id)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>
